import { hasValue, toString } from '@util';
import * as R from 'ramda';

export interface NavItem {
  path: string[];
  label: string;
  icon?: string;
  iconSize?: string;
  badge?: string;
  visible: true;
  aclAction?: string;
}

export interface NavItemProps{
  path: string[];
  label: string;
  icon: string;
  iconSize?: string;
  aclAction?: string;
}

type CreateNavItem = (navItemProps: NavItemProps) => NavItem;
export const createNavItem: CreateNavItem = (navItemProps: NavItemProps) => ({
  path: navItemProps.path,
  label: navItemProps.label,
  icon: navItemProps.icon,
  iconSize: hasValue(navItemProps.iconSize) ? navItemProps.iconSize : 'iconL',
  visible: true,
  aclAction: navItemProps.aclAction
});

export const addNumberOfReferences = (navItem: NavItem, numberOfReferences: number): NavItem =>
  R.mergeRight(navItem, {
    badge: toString(numberOfReferences)
  });
